import BeginPasswordReset from "./BeginPasswordReset.vue";
import { UnAuthorizedLayout } from "~/components";

new Vue({
    delimiters: ["[[", "]]"],
    el: "#begin_password_reset_layout",
    components: {
        BeginPasswordReset,
        UnAuthorizedLayout,
    },
});
